var lib_core      = require("lib-core");

// 3d selection currently only supports single object selection
var Selection3dModel = function (editorModel, cameraModel) {
    lib_core.Model.call(this);
    var self = this;

    this.editorModel = editorModel;

    this.inspectorSubjects = this.set("inspectorSubjects", false);

    this.lastSelectionPoint = null;

    cameraModel.state.onChange("clearSelection", function(val){
        if(val != "none"){
            self.deselectAll();
        }
    });
};


lib_core.inherit(Selection3dModel, lib_core.Model);
Selection3dModel.$class = "Selection3dModel";
module.exports = Selection3dModel;

Selection3dModel.prototype.select = function(model){
    if(!model) return;
    model.select();
    this.inspectorSubjects.add(model);
};

Selection3dModel.prototype.deselect = function(model){
    if(!model) return;
    model.deselect();
    this.inspectorSubjects.remove(model);
};

Selection3dModel.prototype.deselectAll = function(){
    this.inspectorSubjects.forEach(function(item){
        item.deselect();
    });
    this.inspectorSubjects.removeAll();
};


Selection3dModel.prototype.getInspectorSubjects = function() {
    return this.inspectorSubjects;
};

Selection3dModel.prototype.getInspectorSubelementSubject = function() {
    return null;
};
